import type { MarketResearchDemandAnalysisCalculationModelsSearchTrendsNode } from "@similarweb/pro-api-client";

import type { CompareMetricResponse } from "../../search-trends-page/common/types";
import { type IRawDataMetrics, ITotalScoreTypes } from "../../search-trends-page/demand-size/types";
import { selectSearchVolumeData } from "../../search-volume-over-time-widget/searchVolumeOverTimeSelectors";
import { useSearchTrendsQuery } from "../shared/useSearchTrendsQuery";

import type { ITotalSearchesCardData } from "./totalSearches.types";

export const selectTotalSearchesCardData = (
    totalData: IRawDataMetrics | CompareMetricResponse,
    periodDates: string[],
    keywordCount: number,
): ITotalSearchesCardData => {
    const value = "Values" in totalData.Volume ? totalData.Volume.Values.Interval : (totalData.Volume.Value ?? 0);

    return {
        value,
        change: totalData.Volume.Change,
        totalScore: totalData.TotalScore ?? ITotalScoreTypes.STAGNATING,
        dateRange: {
            from: periodDates[0] ?? "",
            to: periodDates[periodDates.length - 1] ?? "",
        },
        keywordCount,
    };
};

const selectTotalSearchesCard = (
    data: MarketResearchDemandAnalysisCalculationModelsSearchTrendsNode,
): ITotalSearchesCardData => {
    // `categories` from the volume selector are the chart x-axis date labels for the period.
    const { totalData, categories: periodDates } = selectSearchVolumeData(data);

    return selectTotalSearchesCardData(totalData, periodDates, data.children?.length ?? 0);
};

export const useTotalSearchesCard = () =>
    useSearchTrendsQuery("marketResearchDemandAnalysisSearchTrendsList", selectTotalSearchesCard);
